/**
 * DataTableCols class
 *
 * @package    DataTable
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { DataTableColumnType } from 'Types';

export default class DataTableFooter extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        columns: PropTypes.arrayOf(DataTableColumnType).isRequired,
    };

    renderCols = () => {
        const { columns } = this.props;

        return columns.map(column => <col key={column.key} {...(column.col ? column.col : {})} />);
    };

    render() {
        return <colgroup>{this.renderCols()}</colgroup>;
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableCols.jsx